import { Checkbox } from "../../../components/checkbox/checkbox";
import { DeleteIcon, FlagIcon } from "../../../assets/icons";
import { useState } from "react";
import { useConfirmPopup } from "../../../components/popup/confirmPopup/confirmPopup";
import AdminAPI from "../../../api/AdminAPI";

import { Text } from "../../../components/text/text";

import styles from "./adminCheckList.module.css"

const getDaysText = (n) => {
    if (n === 1) return "день";
    if ([11, 12, 13, 14].includes(n % 100)) return `${n} дней`;
    if (n % 10 === 1) return `${n} день`;
    if ([2, 3, 4].includes(n % 10)) return `${n} дня`;
    return `${n} дней`;
}

export const CheckListItem = ({ data, setData, isDailyTasks, onDeleteTask }) => {
    const checked = data.countDone >= data.countTotal;

    const [loading, setLoading] = useState(false);

    const [Popup, open] = useConfirmPopup(
        "Подвердите действие",
        "Вы уверены, что хотите удалить задание?",
        () => onDeleteTask(data.id),
    );

    const onToggleDone = () => {
        setLoading(true);

        const req = checked
            ? AdminAPI.cancelAdminTaskCompletion(data.id, data.taskType)
            : AdminAPI.addCompleteStep(data.id, data.taskType, data.countTotal, data.countTotal);

        req
            .then(res => {
                setData(prev => prev.map(item => item.id === data.id ? { ...item, countDone: res.countDone } : item));
            })
            .catch(console.error)
            .finally(() => setLoading(false));
    };

    return (
        <>
            <div className={styles.check_list_item}>
                <div className={styles.check_list_item_extended_header}>
                    <div className={styles.check_list_item_header}>
                        {
                            isDailyTasks &&
                            <Checkbox checked={checked} onChange={onToggleDone} disabled={loading} />
                        }
                        <div className={styles.check_list_item_info}>
                            <Text as="div" variant="body" className={styles.check_list_item_name} >{data.taskText}</Text>
                            <div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
                                {
                                    (data.repeatEveryNDays !== null) &&
                                    <Text as="div" variant="body" className={styles.check_list_item_subname} >{`Раз в ${getDaysText(data.repeatEveryNDays)}`}</Text>
                                }
                                {
                                    !isDailyTasks && data.countTotal > 1 &&
                                    <>
                                        <div className={styles.check_list_progress_target} style={{ justifyContent: "start" }}>
                                            <Text as="div" variant="body" className={styles.check_list_progress_target_text} >{data.countTotal}</Text>
                                            <FlagIcon className={styles.check_list_progress_target_icon} />
                                        </div>
                                    </>
                                }
                            </div>
                        </div>
                    </div>

                    {
                        !isDailyTasks &&
                        <DeleteIcon className={styles.deleteIcon} onClick={open} />
                    }
                </div>
            </div>

            {Popup}
        </>
    );
}